(() => {
  const VERSION = 'akel_needs_v1_2026_09_07';
  const copy = {
    fr: {
      progress: 'Question {current} sur {total}', next: 'Continuer', results: 'Voir ma sélection', skipped: 'Non précisé',
      saved: 'Merci. Votre demande de partage a été acceptée. Vos résultats restent accessibles ici.',
      savedMarketing: 'Merci. Vos réponses et votre demande d’inscription ont été acceptées. Si un courriel de confirmation arrive, confirmez votre inscription.',
      partial: 'Vos réponses ont été enregistrées, mais votre demande complémentaire n’a pas pu être confirmée. Vous pouvez réessayer.',
      error: 'Le partage n’a pas pu être confirmé. Vos résultats restent accessibles. Réessayez ou contactez Akel.',
      sending: 'Envoi en cours…', submit: 'Partager mes réponses', selected: 'Selon vos préférences',
      budget: 'Jusqu’à {amount} {currency}', budgetQuestion: 'Quel budget maximal souhaitez-vous explorer ?',
      budgetHelp: 'En {currency}, avant taxes et livraison. Facultatif; cela ne change pas les prix. Certaines options du même modèle peuvent coûter plus cher.',
      budgetOpen: 'Je veux voir les options d’abord',
      fitHelp: 'Avant de choisir une taille, vérifiez vos mesures avec le guide Akel.', fitCta: 'Consulter le guide des tailles',
      checkedFit: 'Comparez vos mesures avec les tailles réellement offertes pour chaque modèle.',
      firstHelp: 'Commencez par le bonnet et la préparation de la lace. Sur chaque fiche, vérifiez ce qu’Akel prépare et ce qu’il vous restera à faire.',
      routineHelp: 'Une routine simple commence par le bon modèle. Consultez ses conseils de pose, d’entretien et de rangement; les besoins varient selon la texture.',
      proofHelp: 'Comparez les photos réelles, la construction et les options du modèle. Les avis sur la marque ne décrivent pas nécessairement cette perruque précise.',
      styleHelp: 'Comparez les longueurs, les textures et le rendu des modèles ci-dessous. Les suggestions respectent les critères que vous avez choisis.',
      generalHelp: 'Prenez le temps de vérifier les détails qui comptent pour vous. L’équipe Akel peut vous conseiller avant de commander.',
      timingHelp: 'Les commandes sont préparées, emballées et remises au transporteur sous 72 h. Le délai de livraison s’ajoute et dépend de la destination.',
      contact: 'Poser une question à Akel', notesHelp: 'Facultatif, 500 caractères maximum. Ces notes restent uniquement sur cette page. Vous pouvez les copier pour poser une question à Akel. Évitez les renseignements médicaux ou privés.'
    },
    en: {
      progress: 'Question {current} of {total}', next: 'Continue', results: 'See my shortlist', skipped: 'Not specified',
      saved: 'Thank you. Your sharing request was accepted. Your results are still available here.',
      savedMarketing: 'Thank you. Your answers and signup request were accepted. If a confirmation email arrives, confirm your subscription.',
      partial: 'Your answers were saved, but your additional request could not be confirmed. You can try again.',
      error: 'We could not confirm the submission. Your results are still available. Try again or contact Akel.',
      sending: 'Sending…', submit: 'Share my answers', selected: 'Based on your preferences',
      budget: 'Up to {amount} {currency}', budgetQuestion: 'What maximum wig budget would you like to explore?',
      budgetHelp: 'In {currency}, before tax and shipping. Optional; this does not change prices. Other options for the same style may cost more.',
      budgetOpen: 'I want to see the options first',
      fitHelp: 'Before choosing a cap size, check your measurements with Akel’s guide.', fitCta: 'View the size guide',
      checkedFit: 'Compare your measurements with the cap sizes actually offered for each style.',
      firstHelp: 'Start with the cap and lace preparation. Check each product page for what Akel prepares and what you will need to do.',
      routineHelp: 'A simpler routine starts with the right style. Check its fitting, care and storage guidance; different textures have different needs.',
      proofHelp: 'Compare the real product photos, construction and options. Brand reviews do not necessarily describe this particular wig.',
      styleHelp: 'Compare the lengths, textures and looks below. These suggestions respect the preferences you selected.',
      generalHelp: 'Check the details that matter to you. The Akel team can help before you order.',
      timingHelp: 'Orders are prepared, packed and handed to the carrier within 72 hours. Delivery time is additional and depends on the destination.',
      contact: 'Ask Akel a question', notesHelp: 'Optional, up to 500 characters. These notes stay on this page only. You can copy them to ask Akel a question. Please avoid medical or private information.'
    }
  };
  const questions = [
    { id: 'experience', fr: 'Quelle est votre expérience avec les perruques ?', en: 'How much experience do you have with wigs?', options: [
      ['first_time', 'Je choisis ma première perruque', 'I am choosing my first wig'], ['occasional', 'J’en porte à l’occasion', 'I wear one occasionally'], ['regular', 'J’en porte régulièrement', 'I wear wigs regularly'], ['open', 'Je préfère ne pas répondre', 'Prefer not to say']
    ] },
    { id: 'priority', fr: 'Quel point compte le plus dans votre choix en ce moment ?', en: 'What matters most in your decision right now?', options: [
      ['fit', 'La taille du bonnet et la tenue', 'Cap fit and staying in place'], ['natural_result', 'Le rendu de la lace et des cheveux', 'How the lace and hair look'], ['easy_routine', 'Une pose et un entretien simples', 'Simple fitting and upkeep'], ['quality', 'La qualité et la durabilité', 'Quality and durability'], ['budget', 'Le prix', 'Price'], ['style_choice', 'Trouver le style qui me plaît', 'Finding a style I like'], ['timing', 'Le délai pour la recevoir', 'When I can receive it'], ['open', 'Je ne sais pas encore', 'I am not sure yet']
    ] },
    { id: 'texture', fr: 'Quelle texture aimeriez-vous explorer ?', en: 'Which texture would you like to explore?', options: [
      ['straight', 'Lisse', 'Straight'], ['yaki', 'Yaki, avec un fini texturé', 'Yaki, with a textured finish'], ['wavy', 'Ondulée', 'Wavy'], ['curly', 'Bouclée', 'Curly'], ['open', 'Je suis ouverte aux suggestions', 'I am open to suggestions']
    ] },
    { id: 'length', fr: 'Quelle longueur vous attire ?', en: 'Which length appeals to you?', options: [
      ['pixie', 'Très courte / pixie', 'Very short / pixie'], ['bob', 'Carré / bob', 'Bob'], ['medium', 'Mi-longue', 'Medium length'], ['long', 'Longue', 'Long'], ['open', 'Je veux comparer', 'I want to compare']
    ] },
    { id: 'maintenance', fr: 'Quelle routine préférez-vous ?', en: 'What kind of routine do you prefer?', options: [
      ['minimal', 'Le moins de coiffage possible', 'As little styling as possible'], ['regular', 'Une routine régulière me convient', 'I am comfortable with regular upkeep'], ['enjoy_styling', 'J’aime coiffer et changer le rendu', 'I enjoy styling and changing the look'], ['need_guidance', 'J’aimerais comprendre l’entretien d’abord', 'I would like to understand the upkeep first']
    ] },
    { id: 'fit_status', fr: 'Avez-vous vérifié votre taille avec le guide Akel ?', en: 'Have you checked your size with Akel’s guide?', options: [
      ['checked', 'Oui, j’ai pris mes mesures', 'Yes, I have measured'], ['not_yet', 'Pas encore', 'Not yet'], ['need_help', 'J’ai besoin d’aide pour les mesures', 'I need help measuring'], ['open', 'Je préfère passer', 'I would rather skip']
    ] },
    { id: 'budget', options: [['300'], ['500'], ['800'], ['open']] },
    { id: 'notes', fr: 'Y a-t-il autre chose qui vous aiderait à choisir ?', en: 'Is there anything else that would help you choose?', type: 'text' }
  ];

  const avatarFor = (answers) => {
    if (['fit', 'natural_result'].includes(answers.priority)) return 'first_time_chooser';
    if (answers.priority === 'easy_routine') return 'everyday_simplifier';
    if (['quality', 'budget'].includes(answers.priority)) return 'evidence_first_buyer';
    if (answers.priority === 'style_choice') return 'style_explorer';
    if (answers.experience === 'first_time') return 'first_time_chooser';
    if (answers.maintenance === 'minimal') return 'everyday_simplifier';
    return 'undetermined';
  };

  const init = (root) => {
    if (root.dataset.surveyReady === 'true') return;
    root.dataset.surveyReady = 'true';
    const lang = root.dataset.language === 'en' ? 'en' : 'fr';
    const strings = copy[lang];
    const currency = root.dataset.currency || 'CAD';
    const textIndex = lang === 'en' ? 2 : 1;
    const form = root.querySelector('[data-survey-form]');
    const stepHolder = root.querySelector('[data-survey-steps]');
    const results = root.querySelector('[data-survey-results]');
    const progressWrap = root.querySelector('[data-survey-progress-wrap]');
    const progress = root.querySelector('[data-survey-progress]');
    const progressLabel = root.querySelector('[data-survey-progress-label]');
    const next = root.querySelector('[data-survey-next]');
    const back = root.querySelector('[data-survey-back]');
    const products = [...root.querySelectorAll('[data-survey-product]')];
    const shareForm = root.querySelector('[data-survey-share]');
    const instanceId = `akel-survey-${Math.random().toString(36).slice(2, 10)}`;
    const answers = {};
    let step = 0;
    let selectedProducts = [];
    let completionId;
    let completedAt;
    let submitting = false;
    let profileAccepted = false;
    let eventAccepted = false;
    let emailEventAccepted = false;
    let submittedEmail = '';

    const optionLabel = (question, option) => question.id === 'budget'
      ? (option[0] === 'open' ? strings.budgetOpen : strings.budget.replace('{amount}', option[0]).replace('{currency}', currency))
      : option[textIndex];

    questions.forEach((question, index) => {
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'akel-survey__step';
      fieldset.dataset.question = question.id;
      fieldset.hidden = index !== 0;
      const legend = document.createElement('legend');
      legend.tabIndex = -1;
      legend.textContent = question.id === 'budget' ? strings.budgetQuestion : question[lang];
      fieldset.append(legend);
      if (question.id === 'budget' || question.id === 'notes') {
        const help = document.createElement('p');
        help.className = 'akel-survey__help';
        help.id = `${instanceId}-${question.id}-help`;
        help.textContent = question.id === 'budget' ? strings.budgetHelp.replace('{currency}', currency) : strings.notesHelp;
        fieldset.append(help);
      }
      if (question.type === 'text') {
        const notes = document.createElement('textarea');
        notes.name = 'notes';
        notes.maxLength = 500;
        notes.setAttribute('aria-label', question[lang]);
        notes.setAttribute('aria-describedby', `${instanceId}-notes-help`);
        fieldset.append(notes);
      } else {
        const options = document.createElement('div');
        options.className = 'akel-survey__options';
        const ordered = [...question.options];
        if (question.id === 'priority') {
          const pinned = ordered.pop();
          for (let cursor = ordered.length - 1; cursor > 0; cursor -= 1) {
            const target = Math.floor(Math.random() * (cursor + 1));
            [ordered[cursor], ordered[target]] = [ordered[target], ordered[cursor]];
          }
          ordered.push(pinned);
        }
        ordered.forEach((option) => {
          const label = document.createElement('label');
          label.className = 'akel-survey__option';
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = question.id;
          input.value = option[0];
          if (question.id === 'budget') input.setAttribute('aria-describedby', `${instanceId}-budget-help`);
          const text = document.createElement('span');
          text.textContent = optionLabel(question, option);
          label.append(input, text);
          options.append(label);
        });
        fieldset.append(options);
      }
      stepHolder.append(fieldset);
    });

    const steps = [...stepHolder.querySelectorAll('fieldset')];
    const readAnswer = () => {
      const question = questions[step];
      const input = question.type === 'text' ? steps[step].querySelector('textarea') : steps[step].querySelector('input:checked');
      if (input?.value.trim()) answers[question.id] = input.value.trim();
      else delete answers[question.id];
    };
    const showStep = (focus = true) => {
      steps.forEach((fieldset, index) => { fieldset.hidden = index !== step; });
      progress.value = step + 1;
      progressLabel.textContent = strings.progress.replace('{current}', step + 1).replace('{total}', questions.length);
      back.hidden = step === 0;
      next.textContent = step === questions.length - 1 ? strings.results : strings.next;
      if (focus) steps[step].querySelector('legend').focus({ preventScroll: true });
    };
    const addGuide = (text, href, linkText) => {
      const paragraph = document.createElement('p');
      paragraph.textContent = text;
      if (href) {
        paragraph.append(document.createTextNode(' '));
        const link = document.createElement('a');
        link.href = href;
        link.textContent = linkText;
        paragraph.append(link);
      }
      root.querySelector('[data-survey-guidance]').append(paragraph);
    };
    const showResults = () => {
      const budgetLimit = answers.budget && answers.budget !== 'open' ? Number(answers.budget) * 100 : Infinity;
      const easyPreferred = answers.priority === 'easy_routine' || answers.maintenance === 'minimal';
      const seen = new Set();
      selectedProducts = products.filter((product) => {
        if (seen.has(product.dataset.handle)) return false;
        seen.add(product.dataset.handle);
        if (answers.texture && answers.texture !== 'open' && product.dataset.texture !== answers.texture) return false;
        if (answers.length && answers.length !== 'open' && product.dataset.length !== answers.length) return false;
        const price = Number(product.dataset.price);
        return Number.isFinite(price) && price > 0 && price <= budgetLimit;
      }).sort((a, b) => {
        const score = (product) => Number(product.dataset.rank || 0) + (easyPreferred && product.dataset.easy === 'true' ? 100 : 0);
        return score(b) - score(a);
      }).slice(0, 3);
      products.forEach((product) => { product.hidden = true; });
      selectedProducts.forEach((product) => {
        product.hidden = false;
        const bits = ['texture', 'length'].map((id) => {
          const question = questions.find((item) => item.id === id);
          const option = question.options.find((item) => item[0] === product.dataset[id]);
          return option ? option[textIndex] : null;
        }).filter(Boolean);
        product.querySelector('[data-survey-match]').textContent = bits.join(' · ') || strings.selected;
        root.querySelector('[data-survey-products]').append(product);
      });
      root.querySelector('[data-survey-no-match]').hidden = selectedProducts.length > 0;
      const summary = root.querySelector('[data-survey-summary]');
      summary.replaceChildren();
      ['texture', 'length', 'budget'].forEach((id) => {
        if (!answers[id] || answers[id] === 'open') return;
        const question = questions.find((item) => item.id === id);
        const option = question.options.find((item) => item[0] === answers[id]);
        if (!option) return;
        const pill = document.createElement('span');
        pill.textContent = optionLabel(question, option);
        summary.append(pill);
      });
      root.querySelector('[data-survey-guidance]').replaceChildren();
      const guide = { first_time_chooser: strings.firstHelp, everyday_simplifier: strings.routineHelp, evidence_first_buyer: strings.proofHelp, style_explorer: strings.styleHelp, undetermined: strings.generalHelp };
      addGuide(guide[avatarFor(answers)]);
      addGuide(answers.fit_status === 'checked' ? strings.checkedFit : strings.fitHelp, root.dataset.sizeGuide, strings.fitCta);
      if (answers.priority === 'timing') addGuide(strings.timingHelp);
      addGuide('', `mailto:${root.dataset.contactEmail}`, strings.contact);
      form.hidden = true;
      progressWrap.hidden = true;
      results.hidden = false;
      completedAt = new Date().toISOString();
      completionId = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      profileAccepted = false;
      eventAccepted = false;
      emailEventAccepted = false;
      submittedEmail = '';
      if (shareForm) {
        shareForm.reset();
        shareForm.querySelector('[data-survey-share-submit]').disabled = false;
        shareForm.querySelector('[data-survey-share-status]').textContent = '';
      }
      root.querySelector('[data-survey-results-title]').focus({ preventScroll: true });
      results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    };
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      readAnswer();
      if (step === questions.length - 1) showResults();
      else { step += 1; showStep(); }
    });
    root.querySelector('[data-survey-skip]').addEventListener('click', () => {
      delete answers[questions[step].id];
      steps[step].querySelectorAll('input').forEach((input) => { input.checked = false; });
      const note = steps[step].querySelector('textarea');
      if (note) note.value = '';
      if (step === questions.length - 1) showResults();
      else { step += 1; showStep(); }
    });
    back.addEventListener('click', () => { readAnswer(); step = Math.max(0, step - 1); showStep(); });
    root.querySelector('[data-survey-edit]').addEventListener('click', () => {
      results.hidden = true;
      form.hidden = false;
      progressWrap.hidden = false;
      step = 0;
      showStep();
      form.scrollIntoView({ block: 'start' });
    });

    if (shareForm) shareForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting || !shareForm.reportValidity()) return;
      const email = shareForm.elements.email.value.trim().toLowerCase();
      if (shareForm.elements.website.value || !shareForm.elements.share_consent.checked || !completedAt) return;
      const companyId = root.dataset.companyId;
      const listId = root.dataset.listId;
      if (!/^[A-Za-z0-9]{6}$/.test(companyId)) return;
      const marketing = Boolean(shareForm.elements.marketing_consent?.checked && /^[A-Za-z0-9]{6}$/.test(listId));
      const emailRequested = Boolean(shareForm.elements.email_requested?.checked);
      const submit = shareForm.querySelector('[data-survey-share-submit]');
      const status = shareForm.querySelector('[data-survey-share-status]');
      if (submittedEmail !== email) { profileAccepted = false; eventAccepted = false; emailEventAccepted = false; submittedEmail = email; }
      submitting = true;
      submit.disabled = true;
      submit.textContent = strings.sending;
      status.textContent = '';
      status.dataset.error = 'false';
      const properties = {
        akel_survey_version: VERSION, akel_survey_completed_at: completedAt,
        akel_survey_source: 'storefront_customer_survey', akel_survey_page_path: window.location.pathname,
        akel_survey_avatar: avatarFor(answers), akel_survey_currency: currency,
        akel_survey_result_handles: selectedProducts.map((product) => product.dataset.handle),
        akel_survey_share_consent_at: new Date().toISOString(), siteLanguage: lang,
        akel_survey_marketing_opt_in_requested: marketing, akel_survey_email_requested: emailRequested
      };
      questions.filter((question) => question.id !== 'notes').forEach((question) => {
        properties[`akel_survey_${question.id}`] = answers[question.id] || 'unspecified';
      });
      if (currency === 'CAD') properties.akel_survey_budget_cad = answers.budget || 'unspecified';
      const profile = { data: { type: 'profile', attributes: { email, locale: `${lang}-CA`, properties } } };
      const request = async (endpoint, payload) => {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(`https://a.klaviyo.com/client/${endpoint}?company_id=${encodeURIComponent(companyId)}`, {
            method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
            body: JSON.stringify(payload), signal: controller.signal
          });
          if (!response.ok) throw new Error(`Submission ${response.status}`);
        } finally { window.clearTimeout(timeout); }
      };
      try {
        // Keep explicit checkbox choices current if a partial request is retried.
        await request('profiles', profile);
        profileAccepted = true;
        if (!eventAccepted) {
          const eventProperties = { ...properties };
          await request('events', { data: { type: 'event', attributes: {
            properties: eventProperties, unique_id: completionId, time: completedAt,
            metric: { data: { type: 'metric', attributes: { name: 'Akel Survey Completed' } } },
            profile: { data: { type: 'profile', attributes: { email } } }
          } } });
          eventAccepted = true;
        }
        if (marketing) await request('subscriptions', { data: {
          type: 'subscription', attributes: { custom_source: `Akel survey ${VERSION} ${lang}; separate explicit marketing checkbox`, profile: { data: {
            type: 'profile', attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }
          } } }, relationships: { list: { data: { type: 'list', id: listId } } }
        } });
        if (emailRequested && !emailEventAccepted) {
          const resultProducts = selectedProducts.map((product) => ({
            title: product.dataset.title,
            handle: product.dataset.handle,
            url: product.querySelector('a').href,
            image: product.dataset.image ? new URL(product.dataset.image, window.location.origin).href : '',
            price: Number(product.dataset.price) / 100,
            price_formatted: product.dataset.priceFormatted,
            currency
          }));
          await request('events', { data: { type: 'event', attributes: {
            properties: { ...properties, email_requested: true, result_count: resultProducts.length, products: resultProducts },
            unique_id: `${completionId}-email`, time: completedAt,
            metric: { data: { type: 'metric', attributes: { name: 'Akel Survey Email Requested' } } },
            profile: { data: { type: 'profile', attributes: { email } } }
          } } });
          emailEventAccepted = true;
        }
        status.textContent = marketing ? strings.savedMarketing : strings.saved;
      } catch (error) {
        status.textContent = profileAccepted && eventAccepted ? strings.partial : strings.error;
        status.dataset.error = 'true';
        submit.disabled = false;
      } finally {
        submitting = false;
        submit.textContent = strings.submit;
      }
    });
    root.querySelector('[data-survey-interactive]').hidden = false;
    showStep(false);
  };
  document.querySelectorAll('[data-akel-survey]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-akel-survey]').forEach(init));
})();
